<template>
  <router-view />
</template>

<script>
export default {
  name: "BlogView",
  data() {
    return {};
  }
};
</script>
